<template>
    <v-container>
        <v-layout>
            <v-flex xs12 sm10 offset-sm1 lg6 offset-lg3>
                <form @submit.prevent="authenticate" ref="form">
                    <v-card>
                        <v-card-title>
                            <div>
                                <h3 class="headline mb-0" v-t="'title.login'"></h3>
                            </div>
                        </v-card-title>

                        <v-card-text class="text--primary">
                            <v-alert
                                class="mb-3"
                                :value="true"
                                type="error"
                                v-for="error in errors"
                                :key="error"
                                >{{ $t(`error.${error}`) }}</v-alert
                            >
                            <v-text-field
                                @input="email = $event"
                                prepend-icon="email"
                                :loading="loading"
                                :label="$t('label.email')"
                                required
                                type="email"
                            ></v-text-field>

                            <v-text-field
                                @input="password = $event"
                                prepend-icon="lock"
                                :loading="loading"
                                :append-icon="showPassword ? 'visibility_off' : 'visibility'"
                                :type="showPassword ? 'text' : 'password'"
                                :label="$t('label.password')"
                                required
                                @click:append="showPassword = !showPassword"
                            ></v-text-field>

                            <v-layout>
                                <router-link
                                    :to="{ name: 'password-forgotten' }"
                                    color="primary"
                                    v-t="'link.password_forgotten'"
                                ></router-link>
                                <v-spacer></v-spacer>
                                <router-link
                                    text
                                    :to="{ name: 'register' }"
                                    color="primary"
                                    v-t="'button.new_account'"
                                ></router-link>
                            </v-layout>
                        </v-card-text>
                        <button type="submit" style="display: none;" ref="submitButton"></button>
                        <v-card-actions>
                            <v-btn
                                text
                                class="caption"
                                small
                                @click="menuMagicLogin = !menuMagicLogin"
                            >
                                {{ $t("button.email_login") }}
                                <v-icon small right>flare</v-icon>
                            </v-btn>
                            <v-spacer></v-spacer>
                            <div></div>
                            <v-btn
                                color="primary"
                                v-t="'button.login'"
                                type="submit"
                                :disabled="loading"
                                :loading="loading"
                            ></v-btn>
                        </v-card-actions>
                    </v-card>
                </form>
                <v-card v-if="menuMagicLogin" class="mt-2">
                    <v-card-title primary-title>
                        <div>
                            <h3 class="headline mb-0" v-t="'title.email_login'"></h3>
                        </div>
                    </v-card-title>
                    <form @submit.prevent="requestMagicLogin">
                        <v-card-text class="text--primary">
                            <v-alert
                                class="mb-3"
                                :value="true"
                                type="error"
                                v-for="error in magicLoginErrors"
                                :key="error"
                                >{{
                                    $t(`error.${error.key || error}`, {
                                        wait_period: error.wait_period || 0,
                                    })
                                }}</v-alert
                            >
                            <v-text-field
                                @input="emailMagic = $event"
                                prepend-icon="email"
                                :loading="loading"
                                :success="success"
                                :append-icon="success ? 'check_circle' : ''"
                                :label="$t('label.email')"
                                required
                                type="email"
                            ></v-text-field>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>

                            <v-btn
                                text
                                @click="menuMagicLogin = false"
                                v-t="'button.cancel'"
                            ></v-btn>
                            <v-btn
                                :color="success ? 'green' : 'primary'"
                                :dark="success"
                                :loading="loading"
                                :disabled="loading"
                                type="submit"
                            >
                                {{ $t(success ? "button.email_sent" : "button.send") }}
                                <v-icon right v-if="success">check_circle</v-icon>
                            </v-btn>
                        </v-card-actions>
                    </form>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
import loadingMixin from "@/mixins/loading"
import { mapActions, mapGetters, mapMutations } from "vuex"
export default {
    mixins: [loadingMixin],
    data() {
        return {
            rules: {
                required: value => !!value || this.$t("error.required"),
            },

            errors: [],
            magicLoginErrors: [],
            showPassword: false,
            success: false,
            valid: false,
            menuMagicLogin: false,
            emailMagic: null,
            email: null,
            password: null,
        }
    },
    mounted() {
        console.log(this.bestLocal)
        this.setLocale(this.bestLocal)
    },
    computed: {
        ...mapGetters({ bestLocal: "user/bestLocal" }),
    },
    methods: {
        ...mapActions({ login: "user/login" }),
        ...mapMutations({ setLocale: "user/locale" }),
        async authenticate() {
            this.loading = true
            this.errors = []
            try {
                const {
                    data: { authenticate },
                } = await this.$apollo.query({
                    query: require("@/graphql/account/authenticate.gql"),
                    variables: {
                        email: this.email,
                        password: this.password,
                    },
                })
                if (!authenticate) {
                    this.errors = authenticate.errors
                } else {
                    this.login({ token: authenticate.jwt, locale: authenticate.locale })

                    this.$router.push({ name: "dashboard" })
                }
            } catch (error) {
                console.log(error)
                this.errors = error.graphQLErrors.map(e => e.message)
            }
            this.loading = false
        },
        async requestMagicLogin(event) {
            event.preventDefault()
            this.loading = true
            this.magicLoginErrors = []
            try {
                const {
                    data: { requestMagicLogin },
                } = await this.$apollo.mutate({
                    mutation: require("@/graphql/account/requestMagicLogin.gql"),
                    variables: {
                        email: this.emailMagic,
                    },
                })
                if (!requestMagicLogin.result) {
                    this.magicLoginErrors = requestMagicLogin.errors.map(e => {
                        return {
                            key: e,
                            wait_period: requestMagicLogin.wait_period,
                        }
                    })
                } else {
                    this.success = true
                    setTimeout(() => {
                        this.success = false
                        this.menuMagicLogin = false
                    }, 1000)
                }
            } catch (error) {
                this.magicLoginErrors = error.graphQLErrors.map(e => e.message)
            }
            this.loading = false
            return false
        },
    },
}
</script>
